<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body" v-loading = "loading">
			<div class="center">
				<div class="page_links">
					当前位置：
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item :to="{ path: '/uc_order' }">订单管理</el-breadcrumb-item>
						<el-breadcrumb-item>订单详情</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="main_content" v-if="detail">
					<div class="order_status">
						<div class="status_wrap">
							<div>
								<p class="txt">当前订单状态</p>
								<p class="status">{{detail.order.order_status_text}}</p>
							</div>
						<!-- 	<div class="df">
								<p class="btn refuse">拒绝</p>
								<p class="btn aggree">同意</p>
							</div> -->
						</div>
						<div class="detail_wrap" v-if="false">
							<el-descriptions labelClassName="la_style" contentClassName="con_style" :colon="false">
								<el-descriptions-item label="订单号">{{detail.order.order_no}}</el-descriptions-item>
								<el-descriptions-item label="下单时间">{{detail.order.create_time}}</el-descriptions-item>
								<el-descriptions-item label="订单类型">普通订单</el-descriptions-item>
								<el-descriptions-item label="付款时间">{{detail.order.pay_time}}</el-descriptions-item>
								<el-descriptions-item label="完成时间">{{detail.order.finish_time=='1970-01-01 08:00:00'?'-':detail.order.finish_time}}</el-descriptions-item>
								<el-descriptions-item label="支付方式">{{detail.order.pay_type_text}}</el-descriptions-item>
								<el-descriptions-item label="买家备注">{{detail.order.buyer_words}}</el-descriptions-item>
								<el-descriptions-item label="商家备注">{{detail.order.seller_words}}</el-descriptions-item>
							</el-descriptions>
						</div>
					</div>
					<div class="order_infos">
						<div class="info_con" v-if="detail.order_address">
							<el-descriptions title="收货信息" labelClassName="la_style" contentClassName="con_style" :colon="false" :column=1 >
								<el-descriptions-item label="收货人">
								{{detail.order_address.mask_name}}
								<el-tooltip class="item" effect="dark" content="点击查看" placement="top">
									<i class="iconfont el-icon-view" @click="showAddressInfo()"></i>
								</el-tooltip>
								</el-descriptions-item>
								<el-descriptions-item label="手机号码">{{detail.order_address.mask_phone}}></i></el-descriptions-item>
								<el-descriptions-item label="收货地址">{{detail.order_address.province}}{{detail.order_address.city}}{{detail.order_address.town}}{{detail.order_address.mask_detail}}</el-descriptions-item>
							</el-descriptions>
						</div>
						<div class="info_con" v-if="detail.deliver_status==2">
							<el-descriptions title="物流信息" labelClassName="la_style" contentClassName="con_style" 
							:colon="false" :column="1" >
								<el-descriptions-item label="快递公司">{{detail.supplier_order_delivery.company}}</el-descriptions-item>
								<el-descriptions-item label="物流单号">{{detail.supplier_order_delivery.logistics_code}}</el-descriptions-item>
								<el-descriptions-item label="发货时间">{{detail.supplier_order_delivery.update_time}}</el-descriptions-item>
								<el-descriptions-item label="商品信息">
									<div class="goods" v-for="(goods,i) in detail.supplier_order_delivery.supplier_order_delivery_product">
										<el-image class="cover_image" fit="cover" :src="goods.product_pic"></el-image>
										<div class="num">x{{goods.product_count}}</div>
									</div>
								</el-descriptions-item>
							</el-descriptions>
						</div>
					</div>
					<!-- <div class="order_infos">
						<div class="info_con">
							<el-descriptions title="退货信息" labelClassName="la_style" contentClassName="con_style" 
							:colon="false" :column="4">
								<el-descriptions-item label="快递公司">圆通快递</el-descriptions-item>
								<el-descriptions-item label="快递单号">4962990566310610271</el-descriptions-item>
								<el-descriptions-item label="退货地址">福建省 泉州市 洛江区  福建省泉州市洛江区马甲镇***</el-descriptions-item>
							</el-descriptions>
						</div>
					</div> -->
					<div class="order_goods">
						<p class="fb">商品信息</p>
						<div class="table_wrap">
							<el-table :data="detail.supplier_order_product">
								<el-table-column label="货品信息" prop="scope" width="340" >
									<template slot-scope="scope">
										<div class="goods_wrap">
											<div class="img_box"><img class="coverimg" :src="scope.row.product_pic" /></div>
											<div class="con_box">
												<p class="name">{{scope.row.product_name}}</p>
												<p class="color">{{scope.row.spec_value}}</p>
												<p class="bianma">商家：{{detail.order.business.nickname}}</p>
											</div>
										</div>
									</template>
								</el-table-column>
								<el-table-column label="数量" align="left" prop="scope" class="c_price">
									<template slot-scope="scope">
										<!-- <p>{{scope.row.item_amount}}</p> -->
										<p class="num">x{{scope.row.item_num}}</p>
									</template>
								</el-table-column>
								<!-- <el-table-column label="售后状态" prop="scope" width="250">
									<template slot-scope="scope">
										<div class="after_sales" >
											<p>{{scope.row.order_status_text}}</p>
											<p v-if="scope.row.order_after_sales" class="red" style="margin-top: 5px;" @click="showAfterSaleInfo(scope.row)">{{scope.row.order_after_sales.aftersale_status_text}}</p>
											<p class="red" v-if="scope.row.order_after_sales&&(scope.row.order_after_sales.aftersale_status==6||scope.row.order_after_sales.aftersale_status==11)" @click="showAfterSaleInfo(scope.row)">系统将在{{scope.row.order_after_sales.status_deadline_time}}后自动同意</p>
										</div>
									</template>
								</el-table-column> -->
								<!-- <el-table-column label="商品总价" prop="order_amount" width="250"></el-table-column> -->
							</el-table>
						</div>
						<!-- <div class="total_txt">
							<p>商品总价:<em>￥{{detail.order_amount}}</em></span></p>
						</div> -->
					</div>
					
				</div>
			</div>
		</div>
		<!-- 收货地址信息弹窗 -->
		<orderAddress @close="dialog.addressDialog = false" :isLoading.sync="isLoading" :show.sync="dialog.addressDialog" :order_id.sync="order_id"></orderAddress>
		<!-- 售后详情弹窗 -->
		<el-dialog title="售后详情" :visible.sync="dialog.aftersaleDialog" width="70%" center >
			<orderAfterSales @close="dialog.aftersaleDialog = false" @complete="init()" :isLoading.sync="isLoading" :show.sync="dialog.aftersaleDialog" :info.sync="supplier_order_product"></orderAfterSales>
		</el-dialog>
		<myFoot></myFoot>
	</div>
</template>

<script>
import Vue from 'vue';
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import orderAddress from '../../components/orderAddress/orderAddress';
import orderAfterSales from '../../components/orderAfterSales/orderAfterSales';
import { mapActions,mapState,mapMutations } from "vuex";
export default {
	name: "orderDetail",
	data() {
		return {
			order_id:0,
			detail:'',
			dialog: {
				addressDialog:false,
				aftersaleDialog:false,
			},
			isLoading:false,
			supplier_order_product: '',
			loading:false
		}
	},
	components:{
		myHead,myFoot,orderAddress,orderAfterSales
	},
	created(){
		this.order_id = parseInt(this.$route.query.order_id)
		this.init()
	},
	methods: {
		...mapActions({
			getSupplierOrderDetail:"ucenter/getSupplierOrderDetail",
		}),
		init(){
			this.loading =  true
			var param = {order_id:this.order_id}
			this.getSupplierOrderDetail({data:param,success:(res)=>{
				console.log(res)
				this.loading = false
				if(res.code == 200){
					this.detail = res.data
				}else{
					this.$message({message: res.msg,type: 'error',});
				}
			}})
			
		},
		showAddressInfo(){
			this.dialog.addressDialog = true
		},
		showAfterSaleInfo(supplier_order_product){
			this.supplier_order_product = supplier_order_product
			this.dialog.aftersaleDialog = true
		},
	}
}
</script>

<style scoped>
.order_status{margin-top: 30px;width: 100%;height: auto;box-sizing: border-box;padding: 30px 40px 20px;background: #fff;}
.order_status .status_wrap{line-height: 1;padding-bottom: 30px;border-bottom: 1px solid #eee;display: flex;justify-content: space-between;align-items: flex-end;}
.order_status .status_wrap .txt{font-size: 14px;color: #999999;}
.order_status .status_wrap .status{font-size: 24px;margin-top: 16px;}
.order_status .status_wrap .btn{width: 74px;height: 32px;box-sizing: border-box;border: 1px solid;background: #fff;display: flex;justify-content: center;align-items: center;margin-left: 12px;cursor: pointer;font-size: 14px;}
.order_status .status_wrap .btn.refuse{border-color: #ddd;color: #999;}
.order_status .status_wrap .btn.aggree{border-color: #f0413e;color: #f0413e;}

.order_status .detail_wrap{padding-top: 30px;}
.order_infos{margin-top: 15px;width: 100%;height: auto;box-sizing: border-box;padding: 30px 0;background: #fff;display: flex;}
.order_infos .info_con{flex: 1;margin-left: 40px;width: 0;box-sizing: border-box;border-right: 1px solid #eee;}
.order_infos .info_con:last-child{border-right: none;}
.order_goods{margin-top: 15px;width: 100%;height: auto;box-sizing: border-box;padding: 30px 40px;background: #fff;line-height: 1;}
.order_infos .info_con .goods{position: relative;width: 60px;height: 60px;display: inline-block;margin-right: 5px;}
.order_infos .info_con .goods .cover_image{width:60px;height:60px;border: 1px solid #f5f5f5;}
.order_infos .info_con .goods .num{font-size: 12px;position: absolute;bottom:0px;right: 0px;color: #333;background-color: rgba(255,255,255,0.8);padding: 2px 4px;}
.order_infos .info_con .pack_btn{margin-right: 20px;}
.order_goods .table_wrap{margin-top: 30px;font-size: 12px;}
.goods_wrap{width: 100%;box-sizing: border-box;display: flex;}
.goods_wrap .img_box{width: 48px;height: 48px;overflow: hidden;background: #eee;}
.goods_wrap .img_box>img{width: 100%;height: 100%;object-fit: cover;}
.goods_wrap .con_box{width: 200px;margin-left: 10px;text-align: left;}
.goods_wrap .con_box .name{line-height: 16px;color: #333;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;}
.goods_wrap .con_box .color{color: #999999;margin-top: 10px;line-height: 1;}
.goods_wrap .con_box .bianma{color: #999999;margin-top: 6px;line-height: 1;}
.order_goods .total_txt{display: flex;justify-content: flex-end;flex-direction: column;font-size: 12px;color: #999999;align-items: flex-end;padding: 26px 0 15px;}
.order_goods .total_txt span{font-size: 16px;color: #333;}
.order_goods .total_txt span>em{color: var(--red);font-weight: bold;}
.order_goods .total_txt>p:nth-child(2){margin-top: 10px;}
.after_sales p{line-height: 1.3;}
.after_sales{width: 100px;text-align: left;margin-left: 38%;}
.after_sales .red{color: var(--red);cursor: pointer;}
.el-icon-view{cursor: pointer;}
</style>
<style>	
.page_links{line-height: 1;font-size: 14px;color: #999999;display: flex;margin-top: 25px;}
.page_links .el-breadcrumb__inner{font-weight: bold !important;color: #333 !important;}
.page_links .el-breadcrumb__inner.is-link{font-weight: initial !important;color: #999 !important;}
.page_links .el-breadcrumb__inner.is-link:hover{color: #f0423f !important;text-decoration: underline;}

.el-table .el-table_1_column_2 .cell .num{color: #999;}
.el-table th.el-table__cell{background: #fff6f7;border-bottom: none !important;color: #666666;padding: 12px 0;}
.el-table .el-table__cell{vertical-align: top;padding: 24px 0;}
.el-table .cell{padding: 0 20px;text-align: center;font-size: 12px;color: #333;}
.el-table th.el-table__cell>.cell{padding: 0 20px;}
.el-table .el-table_1_column_1 .cell{text-align: left;}
.el-table .el-table_1_column_2 .cell{text-align: right;}
.el-table th.el-table_1_column_1 .cell{text-align: left;}
.el-table th.el-table_1_column_2 .cell{text-align: right;}

.con_style{color: #333;}
.la_style{color: #999;width: 70px;}
.el-descriptions{font-size: 12px;}
.el-descriptions__title{color: #333;}
</style>